import { getLayoutDirection, isMobileApp } from "../../utils/util";

export default function renderModal(id, title, icon, alertText, description, additionalInfo, onClose, close) {


  window.parent.scrollTo(0, 0);

  return (
    <div className={` custombody_color ${getLayoutDirection()}`}>

            <div className="modal fade Custom_Modal_Box show"
      id={id}
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
      style={{ display: 'block' }}>
        
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            {!isMobileApp() &&
              <div className="Title_Inner_Box">
                                    <h6 className="MainTitleOne">{title}</h6>
                                </div>
              }
                        </div>
                        <div className="modal-body">
                            <div className="Inner_Modal_Body">
                                <div
                  className={`AlertInnerBox YellowAlertInnerBox2 `}>
                                    <div className="Icon_box">
                                        <span className="material-symbols-outlined">{icon}</span>
                                    </div>
                                    <div className="alert_text">
                                        <h6>{alertText}</h6>
                                    </div>
                                </div>
                                <div className="para_common_box">
                                    <p className="para_txt">{description}</p>
                                    {additionalInfo && <p className="para_txt">{additionalInfo}</p>}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer modal_footer_btn_box">
                            <button type="button" onClick={onClose} className="btn bluetrans_btn_link"
              data-dismiss="modal">
                                {close || "Close"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
}